import styled from 'styled-components';
import { colors, spacing, fontWeights, body1, body2, fontSizes } from 'ui/theme';

export const NavigationContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: ${spacing.quarter};
  justify-content: space-between;
`;

export const NavigationLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${spacing.half};
  margin-right: ${spacing.half};
  font-size: ${fontSizes.s12};
  color: ${colors.grey80};
`;

export const ReviewNeededContainer = styled.div`
  border-bottom: ${spacing.single} ${colors.borderPrimarySubtle} solid;
  padding: ${spacing.threeQuarter};
`;

export const ReviewNeededMsg = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${colors.backgroundWarningSubtle};
  border: ${spacing.single} ${colors.borderWarningSubtle} solid;
  border-radius: ${spacing.quarter};
  margin-bottom: ${spacing.half};
  padding: ${spacing.threeQuarter};
`;

export const ReviewNeededMsgHeader = styled.div`
  ${body1}
  color: ${colors.textWarning};
  font-weight: ${fontWeights.medium};
  margin-bottom: ${spacing.quarter};
`;

export const ReviewNeededMsgBody = styled.div`
  ${body2}
  color: ${colors.warning100};
`;
